'use strict';

delivery.$inject = ["DeliveryProduct"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.delivery = delivery;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function delivery(DeliveryProduct) {
    var clazz = function Delivery() {
        var defaults = {
            id: 0,
            state: '',
            amount: '',
            history: null,
            products: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.deliveryNr;
        o.state = resource.deliveryState;
        o.amount = resource.deliveryAmount;
        o.history = _lodash2.default.map(resource.deliveryHistory, function (i) {
            return { date: i.date, time: i.time, text: i.text };
        });
        o.products = _lodash2.default.map(resource.products, function (i) {
            return DeliveryProduct.create(i);
        });
        return o;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/deliveryModel.js
// module id = 744
// module chunks = 0